export default __webpack_public_path__ + "static/media/app3.175fe094.png";